import { defaultUserPreferences } from './constants/constants';

export function parseUserPreferenceValue(response) {
    try {
        const parsed = JSON.parse(response.value);
        return {
            ...defaultUserPreferences,
            ...parsed,
        };
    } catch {
        return defaultUserPreferences;
    }
}

export function getUserPreferenceKey(...keyParts) {
    return `${keyParts.join('_')}`.toLowerCase();
}
